import type { HouseholdStage } from '@savvy/constants/generated/gql-enums';
import { HOUSEHOLD_STAGE_INACTIVE, HOUSEHOLD_STAGE_WON } from '@savvy/constants/household-stages';

/**
 * Checks if a household is considered a client based on the given stage.
 * Inactive (archived) households are also considered clients because only clients can be archived.
 */
export function isClient(householdStage: HouseholdStage | null | undefined): boolean {
  return householdStage === HOUSEHOLD_STAGE_WON || householdStage === HOUSEHOLD_STAGE_INACTIVE;
}
